import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

/**
 * Direktive die auf das 'drop'-Event lauscht und das gedroppte File als Events ausgibt.
 *
 * @author Valentin Kennke (vake@mms-dresden.de)(valentin.kennke@t-systems.com)
 */
@Directive({ selector: '[fileDrop]' })
export class FileDropDirective {

    @Output() private filesDropped: EventEmitter<File[]> = new EventEmitter<File[]>();

    @HostListener('drop', ['$event'])
    public onDrop(event: any): void {
        event.preventDefault();
        const files: File[] = Array.from(this.getTransfer(event).files);
        if (files.length > 0) {
            this.filesDropped.emit(files);
        }
    }

    @HostListener('dragover', ['$event'])
    public onDragOver(event: any): void {
        const transfer = this.getTransfer(event);
        if (!this.haveFiles(transfer.types)) {
            return;
        }

        transfer.dropEffect = 'copy';
        event.preventDefault();
    }

    private getTransfer(event: any) {
        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer;
    }

    private haveFiles(types: any): any {
        if (!types) {
            return false;
        }

        if (types.indexOf) {
            return types.indexOf('Files') !== -1;
        } else if (types.contains) {
            return types.contains('Files');
        } else {
            return false;
        }
    }
}
